import { render, staticRenderFns } from "./incoming.vue?vue&type=template&id=31a113fd"
import script from "./incoming.vue?vue&type=script&lang=js"
export * from "./incoming.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports